import { Card, CardContent, Typography, Grid } from '@material-ui/core'
// import dateFormat from "dateformat";
import { TFunction } from 'i18next'
import { FC } from 'react'
import { MuiClasses } from '../../../../types'
import { ReserveData, ReservedShowing } from '../../../../types/showings'
import ShowingCard from '../../Overview/ShowingCard'
// import { SuggestReservableCard } from "../SuggestReservableCard";

export interface ReservedCardProps {
  reserveData: ReserveData
  reserved: ReservedShowing
  address?: string
  t: TFunction
  classes: MuiClasses
}

const ReservedCard: FC<ReservedCardProps> = ({
  reserved,
  classes,
  address,
  t
}) => {
  return (
    <Grid container justify='center' className={classes.cardWrapper}>
      <CardContent>
        <Grid item sm={12} md={12} className={classes.centerTitle}>
          <Typography
            variant='h5'
            className={classes.titleReserveCard}
            style={{ textAlign: 'center', marginBottom: '1rem' }}
          >
            {t('showings.reserve.reserved')}
          </Typography>
        </Grid>

        <ShowingCard
          showing={reserved}
          t={t}
          useCase={'empty'}
          address={address}
        />
        <Card className={classes.cardInfo}>
          <Typography variant='body1' style={{ textAlign: 'center' }}>
            {`${t('showings.reserve.success')}`}
          </Typography>
        </Card>
      </CardContent>
    </Grid>
  )
}

export default ReservedCard
